import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import barba from '@barba/core'
import htmx from 'htmx.org'

// Components
import { initAlpine } from './alpine.js';
import { initLenis, scrollToStart } from './lenis.js';
import { initSwiper } from './swiper.js';
import { Navigation } from './navigation.js';
import { initCSSMarquee } from './marquee.js';
import { initSprig } from './sprig.js';
import { initCursor } from './cursor.js';
import { initAwards } from './awards.js';
import { initCards } from './cards.js';
import { initAnimations } from './animation.js';
import { initImageRow } from './imageRow.js';
import { initAwardsGridImages } from './animation.js';
import { initSplitText } from './split.js';
import { initStatistics } from './count.js';
import { initHighlightText } from './highlightText.js';
import { initEnterAnimation, initGlobalParallax } from './animation.js';
import { runPageOnceAnimation, runPageLeaveAnimation, runPageEnterAnimation } from './transition.js';
import { initInviewAnimations } from './inview.js';
import { initEventTracking } from './analytics.js';
import { initFormie } from './utilities.js';

gsap.registerPlugin(ScrollTrigger)

export const initBarba = () => {
	window.initialLoad = true

	const failsafeId = setTimeout(() => {
		document.documentElement.classList.add('is-ready')
	}, 3000)

	const nav = new Navigation()

	const initComponents = (data) => {

		console.log('initComponents')

		initSwiper()
		initInviewAnimations()
		initSplitText()
		initHighlightText()
		initCards()
		initCSSMarquee()
		initAnimations()
		initAwardsGridImages()
		initGlobalParallax()
		initSprig()
		initAwards()
		initImageRow()
		initStatistics()
		initEventTracking()
	}

	barba.init({
		debug: false,
		timeout: 7000,
		preventRunning: true,
		schema: {
			prefix: 'data-load'
		},
		transitions: [
			{
				name: 'swipe-transition',
				sync: true,
				async once(data) {
					return runPageOnceAnimation(data.next.container)
				},
				async leave(data) {
					return runPageLeaveAnimation(data.current.container, data.next.container)
				},
				async enter(data) {
					return runPageEnterAnimation(data.next.container)
				}
			}
		]
	})

	barba.hooks.once((data) => {

		const markReady = () => {
			clearTimeout(failsafeId)
			window.initialLoad = false
			document.documentElement.classList.add('is-ready')
		}

		if (document.readyState === 'complete') {
			markReady()
		} else {
			window.addEventListener('load', markReady, { once: true })
		}

		initLenis()
		initAlpine()
		initComponents(data)
		initEnterAnimation()
		initCursor()
	})

	barba.hooks.leave((data) => {
		nav.closeNavigation()
	})

	barba.hooks.afterLeave((data) => {
		scrollToStart()
		ScrollTrigger.getAll().forEach(t => t.kill())
	})

	barba.hooks.beforeEnter((data) => {
		gsap.set(data.next.container, {
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
		})
	})

	barba.hooks.enter((data) => {
		nav.setActiveState()

		if (htmx) {
			htmx.process(data.next.container)
		}
	})
	
	barba.hooks.after((data) => {
		initComponents(data)
		initFormie()

		if (window.__pgCalibrateEmbed) {
			data.next.container.querySelectorAll('[data-pg-calibrate]').forEach((el) => {
				window.__pgCalibrateEmbed.init(el)
			})
		}
	})
}
